import {
    GETACCOUNTSTRANSACTIONHEADER,
    CREATEHRSALARYADVANCEISSUE,
    CREATEHRSALARYADVANCESETTLEMENTISSUE,
    CREATEHRSTAFFATTENDANCE,
    CREATEHRSTAFFLEAVE,
    CREATEHRSTAFFLEAVEAPPROVE,
    CREATEHRSTAFFPAYROLLDEDUCTION,
    CREATEHRSTAFFPAYROLLINFO,
    CREATEHRSTAFFPAYROLLPAYMENT,
    DELETEHRSTAFFATTENDANCE,
    DELETEHRSTAFFLEAVE,
    DELETEHRSTAFFLEAVEAPPROVE,
    DELETEHRSTAFFPAYROLLDEDUCTION,
    DELETEHRSTAFFPAYROLLINFO,
    DELETEHRSTAFFPAYROLLPAYMENT,
    GETALLHRSTAFFPAYROLLINFO,
    GETHRSTAFFATTENDANCE,
    GETHRSTAFFLEAVE,
    GETHRSTAFFLEAVEAPPROVE,
    GETHRSTAFFPAYROLLDEDUCTION,
    GETHRSTAFFPAYROLLINFO,
    GETHRSTAFFPAYROLLPAYMENT,
    UPDATEHRSTAFFATTENDANCE,
    UPDATEHRSTAFFLEAVE,
    UPDATEHRSTAFFLEAVEAPPROVE,
    UPDATEHRSTAFFPAYROLLDEDUCTION,
    UPDATEHRSTAFFPAYROLLINFO,
    UPDATEHRSTAFFPAYROLLPAYMENT
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHRSTAFFATTENDANCE:
            return {
                ...state,
                hrstaffattendancelistSaveStatus: action.payload.success,
            }
        case GETHRSTAFFATTENDANCE:
            return {
                ...state,
                hrstaffattendanceList: action.payload.data,
            }
        case UPDATEHRSTAFFATTENDANCE:
            return {
                ...state,
                hrstaffattendanceUpdateStatus: action.payload.success,
            }

        case DELETEHRSTAFFATTENDANCE:
            return {
                ...state,
                hrstaffattendanceDeleteStatus: action.payload.success,
            }
        case CREATEHRSTAFFPAYROLLDEDUCTION:
            return {
                ...state,
                hrstaffpayrolldeductionlistSaveStatus: action.payload.success,
            }
        case GETHRSTAFFPAYROLLDEDUCTION:
            return {
                ...state,
                hrstaffpayrolldeductionList: action.payload.data,
            }
        case UPDATEHRSTAFFPAYROLLDEDUCTION:
            return {
                ...state,
                hrstaffpayrolldeductionUpdateStatus: action.payload.success,
            }

        case DELETEHRSTAFFPAYROLLDEDUCTION:
            return {
                ...state,
                hrstaffpayrolldeductionDeleteStatus: action.payload.success,
            }
        case CREATEHRSTAFFPAYROLLINFO:
            return {
                ...state,
                hrstaffpayrollinfolistSaveStatus: action.payload.success,
            }
        case GETHRSTAFFPAYROLLINFO:
            return {
                ...state,
                hrstaffpayrollinfoList: action.payload.data,
            }
        case GETALLHRSTAFFPAYROLLINFO:
            return {
                ...state,
                allhrstaffpayrollinfoList: action.payload.data,
            }
        case UPDATEHRSTAFFPAYROLLINFO:
            return {
                ...state,
                hrstaffpayrollinfoUpdateStatus: action.payload.success,
            }

        case DELETEHRSTAFFPAYROLLINFO:
            return {
                ...state,
                hrstaffpayrollinfoDeleteStatus: action.payload.success,
            }
        case CREATEHRSTAFFPAYROLLPAYMENT:
            return {
                ...state,
                hrstaffpayrollpaymentlistSaveStatus: action.payload.success,
            }
        case GETHRSTAFFPAYROLLPAYMENT:
            return {
                ...state,
                hrstaffpayrollpaymentList: action.payload.data,
            }
        case UPDATEHRSTAFFPAYROLLPAYMENT:
            return {
                ...state,
                hrstaffpayrollpaymentUpdateStatus: action.payload.success,
            }

        case DELETEHRSTAFFPAYROLLPAYMENT:
            return {
                ...state,
                hrstaffpayrollpaymentDeleteStatus: action.payload.success,
            }
        case CREATEHRSTAFFLEAVE:
            return {
                ...state,
                hrstaffleavelistSaveStatus: action.payload.success,
            }
        case GETHRSTAFFLEAVE:
            return {
                ...state,
                hrstaffleaveList: action.payload.data,
            }
        case UPDATEHRSTAFFLEAVE:
            return {
                ...state,
                hrstaffleaveUpdateStatus: action.payload.success,
            }

        case DELETEHRSTAFFLEAVE:
            return {
                ...state,
                hrstaffleaveDeleteStatus: action.payload.success,
            }
        case CREATEHRSTAFFLEAVEAPPROVE:
            return {
                ...state,
                hrstaffleaveapprovelistSaveStatus: action.payload.success,
            }
        case GETHRSTAFFLEAVEAPPROVE:
            return {
                ...state,
                hrstaffleaveapproveList: action.payload.data,
            }
        case UPDATEHRSTAFFLEAVEAPPROVE:
            return {
                ...state,
                hrstaffleaveapproveUpdateStatus: action.payload.success,
            }

        case DELETEHRSTAFFLEAVEAPPROVE:
            return {
                ...state,
                hrstaffleaveapproveDeleteStatus: action.payload.success,
            }

        case CREATEHRSALARYADVANCEISSUE: return { ...state, HRAdvanceSalaryIssueSaveStatus: action.payload.success, }
        case CREATEHRSALARYADVANCESETTLEMENTISSUE: return { ...state, HRAdvanceSalarySettlementIssueSaveStatus: action.payload.success, }
        case GETACCOUNTSTRANSACTIONHEADER:
            return {
                ...state,
                AccountTransactionHeaderList: action.payload.data,
            }



        default:
            return state
    }
}